import { exceptions } from "../../errors";

export function Entity(){
  throw exceptions.Type();
}
